module.exports = __webpack_public_path__ + "img/login.6899b9c9.png";